import { render, staticRenderFns } from "./unload.vue?vue&type=template&id=2601d0d6&scoped=true&"
import script from "./unload.vue?vue&type=script&lang=js&"
export * from "./unload.vue?vue&type=script&lang=js&"
import style0 from "./unload.vue?vue&type=style&index=0&id=2601d0d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601d0d6",
  null
  
)

export default component.exports